import React, { useState } from 'react'
import styled from 'styled-components'
import { AlertTriangle } from 'react-feather'
import WarningModal from '../WarningModal'

const FloatingButton = styled.button`
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(248, 45, 58, 0.9);
  border: 2px solid #f82d3a;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
  box-shadow: 0 8px 32px rgba(248, 45, 58, 0.3);
  transition: all 0.2s ease;
  z-index: 1000;

  &:hover {
    background: #f82d3a;
    transform: scale(1.05);
    box-shadow: 0 12px 40px rgba(248, 45, 58, 0.4);
  }

  @media screen and (max-width: 768px) {
    bottom: 24px;
    right: 24px;
    width: 48px;
    height: 48px;
  }
`

const SafetyIndicator = ({ type, address }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <FloatingButton onClick={() => setShowModal(true)} title="View Token Safety Information">
        <AlertTriangle size={24} />
      </FloatingButton>

      <WarningModal type={type} show={showModal} setShow={setShowModal} address={address} />
    </>
  )
}

export default SafetyIndicator
